import { forwardRef, ReactNode } from "react";
import clsx from "clsx";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ className, children, ...props }, ref) => {
  const buttonClassName = clsx(
    "h-8 flex justify-center items-center hover:bg-slate-300 rounded-sm",
    "focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus",
    "transition-colors duration-200",
    className,
  );

  return (
    <button ref={ref} className={buttonClassName} {...props}>
      {children}
    </button>
  );
});

Button.displayName = "Button";
